import { Outlet } from "react-router-dom";

const PendingDevice = () => {

  return <Outlet />
}

export default PendingDevice;